<nav
  class="navbar navbar-expand p-0 hide-scrollbar"
  id="mainMenu"
  attr.aria-label="{{ 'wcag.mainMenu' | translate }}"
>
  <ul class="navbar-nav justify-content-center gap-1 mb-lg-2 w-100 px-2">
    <ng-container *ngIf="navbarState$ | async as navbarState">
      <ng-container
        *ngFor="let menuItem of navbarState.menuItems; let index = index"
      >
        <ng-container
          *ngIf="
            navbarState.showScan &&
            index === getScanButtonIndex(navbarState.menuItems)
          "
        >
          <ng-container *ngTemplateOutlet="scanButton"></ng-container>
        </ng-container>

        <li class="nav-item">
          <a
            class="nav-link w-100"
            [routerLink]="menuItem.link"
            [queryParams]="menuItem.queryParams"
            routerLinkActive="active"
            #rla="routerLinkActive"
            [routerLinkActiveOptions]="{
              paths: 'exact',
              queryParams: 'ignored',
              fragment: 'ignored',
              matrixParams: 'ignored'
            }"
            (click)="ticketingReset.emit(); handleLinkClick(menuItem, $event)"
            href="javascript:;"
            [attr.aria-current]="rla.isActive ? 'page' : null"
          >
            <i
              class="fa fa-{{ menuItem.icon }}"
              aria-hidden="true"
              role="img"
            ></i>
            <span
              class="nav-text d-block w-100 overflow-hidden text-center text-truncate"
            >
              {{ menuItem.translateString | translate }}
            </span>
          </a>
        </li>
      </ng-container>

      <ng-container
        *ngIf="
          navbarState.showScan &&
          getScanButtonIndex(navbarState.menuItems) ===
            navbarState.menuItems.length
        "
      >
        <ng-container *ngTemplateOutlet="scanButton"></ng-container>
      </ng-container>
    </ng-container>
  </ul>
</nav>

<ng-template #scanButton>
  <li
    class="nav-item mobile-navbar-scan-item d-flex align-items-center justify-content-center"
  >
    <a
      class="btn btn-primary btn-icon rounded-pill mobile-navbar-scan-link"
      (click)="onClickScan.emit()"
      href="javascript:;"
      data-test-id="primary-nav-bar-menu-item-scan"
      [attr.aria-label]="'general.scan' | translate"
    >
      <i class="fa-regular fa-qrcode" aria-hidden="true" role="img"></i>
    </a>
  </li>
</ng-template>
